// old imports

// needed to make kits UI work
require("../legacy/js/_kits").default;

// new imports
import React from "react";
import classnames from "classnames";
import * as actions from "../actions/actions";
import { connect } from "react-redux";
import defer from "lodash/defer";
import { REDUCER_KEY } from "redux-windowsize";
import ColorSelection from "./color-selection";
import ColorPicker from "./nounproject-color-picker";
import { SuperUserActions } from "./fort-super-user-actions";
import IconView from "./nounproject-icon-view";
import IconDownloadFlow from "./nounproject-icon-download-flow";
import Metrics from "../legacy/helpers/metrics";
import IconRelatedIcons from "./download-flow/icon-related-icons";
import IconShare from "./download-flow/icon-share";
import { phases, licenses } from "../reducers/download";

class NounProjectIconHero extends React.Component {
    constructor(props) {
        super(props);

        this.containerEl = null;
        this.setContainerEl = this.setContainerEl.bind(this);
        this.state = {};
    }

    setContainerEl(el) {
        this.containerEl = el;

        if (this.props.scrollToElement && this.state.wantsScroll) {
            this.props.uiScrollToElement(this.containerEl);

            this.setState({
                wantsScroll: false
            });
        }
    }
    componentWillMount() {
        this.props.getIconMetaData();
    }
    componentDidMount() {
        if (this.props.scrollToElement) {
            if (this.containerEl) {
                this.props.uiScrollToElement(this.containerEl);
            } else {
                this.setState({
                    wantsScroll: true
                });
            }
        }

        if (this.props.icon !== undefined) {
            return new Metrics().icon_hero(this.props.icon.id);
        }

        return null;
    }

    componentDidUpdate(prevProps) {
        if (this.props.scrollToElement) {
            if (prevProps.icon && this.props.icon) {
                if (this.props.icon.id != prevProps.icon.id) {
                    this.props.uiScrollToElement(this.containerEl);
                }
            }

            if (
                this.props.showInModal &&
                prevProps.status != this.props.status
            ) {
                if (this.props.status == phases.INITIAL) {
                    defer(() => this.props.uiScrollToElement(this.containerEl));
                }
            }
        }
    }

    render() {
        let { status, license, usingPremiumFeatures } = this.props;

        let superUserActions;

        if (this.props.icon) {
            if (
                this.props.icon &&
                this.props.currentUser !== undefined &&
                this.props.currentUser.is_superuser
            ) {
                superUserActions = (
                    <SuperUserActions
                        superUser={this.props.currentUser.is_superuser}
                        iconId={this.props.icon.id}
                        uploaderId={this.props.icon.uploader_id}
                    />
                );
            }

            let closeButton,
                heroPreview,
                heroEditing,
                heroMeta,
                iconCollections,
                nonEditableCollections = ["615", "851", "911"],
                isEditable = true,
                withAttribution;

            if (this.props.onCloseAction) {
                closeButton = (
                    <div
                        className="esc-page ui_close"
                        title="Close this menu"
                        onClick={this.props.onCloseAction.bind(this)}
                    />
                );
            }

            // iconCollections = this.props.icon.collections;
            // if (iconCollections) {
            //     if (iconCollections.length > 0) {
            //         if (
            //             nonEditableCollections.includes(
            //                 iconCollections[0].id
            //             )
            //         ) {
            //             isEditable = false;
            //         }
            //     }
            // } else {
            //     if (
            //         nonEditableCollections.includes(
            //             this.props.collection.id
            //         )
            //     ) {
            //         isEditable = false;
            //     }
            // }

            isEditable = true;
            withAttribution = license == licenses.CREATIVE_COMMONS; //&& !usingPremiumFeatures;

            let showingInModal =
                this.props.showInModal && status != phases.INITIAL;

            if (this.props.icon) {
                // if (!showingInModal) {
                heroPreview = (
                    <IconView
                        imgSize={451}
                        icon={this.props.icon}
                        withAttribution={withAttribution}
                    />
                );
                // }
            }

            heroMeta = (
                <IconDownloadFlow
                    showInModal={this.props.showInModal}
                    collection={this.props.collection}
                    icon={this.props.icon}
                    refetchIcon={this.props.refetchIcon}
                    onCloseAction={this.props.onCloseAction}
                />
            );

            if (isEditable) {
                heroEditing = (
                    <ColorSelection
                        store={this.props.store}
                        icon={this.props.icon}
                    />
                );
            }

            let viewMore;
            if (
                (status == phases.INITIAL || status == phases.DOWNLOAD_READY) &&
                this.props.showInModal
            ) {
                viewMore = (
                    <IconRelatedIcons
                        icon={this.props.icon}
                        iconId={this.props.iconId}
                        className="container"
                    />
                );
            }

            let containerClass = classnames("view-container", {
                "icon-editable": isEditable
            });
            return (
                <section
                    className="nounproject-icon-hero"
                    ref={this.setContainerEl}
                >
                    <div className="hero-page-width-container margin-b-m">
                        {superUserActions}
                        <div className={containerClass}>
                            {heroPreview}
                            {heroEditing}
                        </div>
                        {heroMeta}
                        <div className="download-icon-actions">
                            {closeButton}
                            <IconShare
                                icon={this.props.icon}
                                showModal={this.props.showModal}
                            />
                        </div>
                    </div>
                    {viewMore}
                </section>
            );
        } else {
            return null;
        }
    }
}

const HeroAttributionToggle = props => {
    let enabled = props.previewAttribution ? "x" : "";
    let className = classnames("hero-attribution-toggle", {
        enabled
    });
    return (
        <div
            className={className}
            onClick={props.toggle.bind(null, props.icon.id)}
        >
            {enabled} Include Attribution
        </div>
    );
};

function mapStateToProps(state, props) {
    let { download } = state;
    let viewport = state[REDUCER_KEY];

    let { status, license, usingPremiumFeatures, isPremiumUser } = download;

    let apiResponse = state.apiResponse,
        icon,
        currentUser;

    if (
        download &&
        props.icon &&
        download.pendingDownload &&
        download.pendingDownload.id == props.icon.id
    ) {
        icon = download.pendingDownload;
    } else {
        icon = props.icon;
    }

    if (!icon) {
        let { icons } = state;
        let storedIcon =
            icons[props.iconId] ||
            (icons.featured_icons && icons.featured_icons[props.iconId]);
        if (storedIcon) {
            icon = storedIcon;
        }
    }

    if (state.user.is_anonymous !== undefined) {
        currentUser = state.user;
    }

    return {
        status,
        apiResponse,
        icon,
        currentUser,
        license,
        viewport,
        usingPremiumFeatures,
        isPremiumUser
    };
}

module.exports = connect(mapStateToProps, {
    getIconMetaData: actions.getIconMetaData,
    getCurrentUser: actions.getCurrentUser,
    downloadSetPreviewAttribution: actions.downloadSetPreviewAttribution,
    uiScrollToElement: actions.uiScrollToElement,
    showModal: actions.showModal
})(NounProjectIconHero);
